import { FC } from "react";

import { RecordsGrid } from "../../components/RecordsGrid";

const HomePage: FC = () => {
  return <RecordsGrid />;
};

export default HomePage;
